import { render } from "./IntellectualPropertyQuery.vue?vue&type=template&id=a1786df8&scoped=true"
import script from "./IntellectualPropertyQuery.vue?vue&type=script&lang=js"
export * from "./IntellectualPropertyQuery.vue?vue&type=script&lang=js"

import "./IntellectualPropertyQuery.vue?vue&type=style&index=0&id=a1786df8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1786df8"]])

export default __exports__